
const awsExportsDWP = {
    Auth: {
        region: process.env.REACT_APP_Region,
        userPoolId: process.env.REACT_APP_UserPoolId,
        userPoolWebClientId: process.env.REACT_APP_UserPoolWebClientId
    },
    API: {
        endpoints: [
            {
                name: "getUserInfo",
                endpoint: process.env.REACT_APP_FccApiEndpoint
            },
            {
                name: "getModelList",
                endpoint: process.env.REACT_APP_FccApiEndpoint
            },
            {
                name: "getOsList",
                endpoint: process.env.REACT_APP_FccApiEndpoint
            },
            {
                name: "getSwList",
                endpoint: process.env.REACT_APP_FccApiEndpoint
            },
            {
                name: "getHwList",
                endpoint: process.env.REACT_APP_FccApiEndpoint
            },
            {
                name: "getProductList",
                endpoint: process.env.REACT_APP_FccApiEndpoint
            },
            {
                name: "getInquiry",
                endpoint: process.env.REACT_APP_FccApiEndpoint
            },
            {
                name: "getInquiryList",
                endpoint: process.env.REACT_APP_FccApiEndpoint
            },
            {
                name: "addNewInquiry",
                endpoint: process.env.REACT_APP_FccApiEndpoint
            },
            {
                name: "addAdditionalInquiry",
                endpoint: process.env.REACT_APP_FccApiEndpoint
            },
            {
                name: "updateUserInfo",
                endpoint: process.env.REACT_APP_FccApiEndpoint
            },
            {
                name: "addUserInfo",
                endpoint: process.env.REACT_APP_FccApiEndpoint
            },
            {
                name: "createFile",
                endpoint: process.env.REACT_APP_DcmApiEndpoint
            },
            {
                name: "getFileURL",
                endpoint: process.env.REACT_APP_DcmApiEndpoint
            },
            {
                name: "getCertificateDisplay",
                endpoint: process.env.REACT_APP_DcmApiEndpoint
            },
            {
                name: "controlDocInfo",
                endpoint: process.env.REACT_APP_DcmApiEndpoint
            }
        ]
    },
    oauth: {
        domain: process.env.REACT_APP_OAuthDomain,
        scope: ["email", "openid", "profile", "aws.cognito.signin.user.admin"],
        redirectSignIn: process.env.REACT_APP_OAuthRedirectSignInUrl,
        redirectSignOut: process.env.REACT_APP_OAuthRedirectSignOutUrl,
        responseType: "code"
    },
    custom_provider: "AzureAD" //独自プロパティ
};

export default awsExportsDWP;

